

exports.__esModule = true;
exports.$xoFrameBustPageDirective = undefined;

var _uiRouter = require('uiRouter');

var _index = require('squid/index');

var _icFallback = require('js/lib/icFallback');

var _template = require('./template');

var _template2 = _interopRequireDefault(_template);

require('./styles');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

var $xoFrameBustPageDirective = exports.$xoFrameBustPageDirective = _index.$Component.extend('$xoFrameBustPageDirective', {

    tag: 'xo-framebust-page',
    template: _template2['default'],

    props: {},

    resolve: {},

    actions: {
        submit: function submit() {

            window.paypalCheckout.hide();

            var url = decodeURIComponent(_uiRouter.$stateParams.url);

            if (_uiRouter.$stateParams.action === 'open') {

                var props = window.paypalCheckout.props;

                return window.ppxo.Checkout.renderPopupTo(window.top, {

                    url: url,

                    payment: props.payment,
                    billingAgreement: props.billingAgreement,

                    onAuthorize: props.onAuthorize,
                    onCancel: props.onCancel

                });
            }

            if (_uiRouter.$stateParams.action === 'fallback') {

                var _props = window.paypalCheckout.props;

                var component = window.ppxo.Checkout.init({

                    url: url,

                    payment: _props.payment,
                    billingAgreement: _props.billingAgreement,

                    onAuthorize: _props.onAuthorize,
                    onCancel: _props.onCancel,

                    dimensions: {
                        width: 970,
                        height: 850
                    }
                });

                component.renderTo(window.top, null, 'popup');

                (0, _icFallback.$incontextFallback)(component.window, url);
            }
        }
    }
});

angular.value("$xoFrameBustPageDirective", $xoFrameBustPageDirective);
_uiRouter.$stateParams;

_index.$Component;

_icFallback.$incontextFallback;


//////////////////
// WEBPACK FOOTER
// ./pages/xo-framebust/directive.js
// module id = ./pages/xo-framebust/directive.js
// module chunks = 1